import { render, staticRenderFns } from "./BookingDeleted.vue?vue&type=template&id=d497272a"
import script from "./BookingDeleted.vue?vue&type=script&lang=js"
export * from "./BookingDeleted.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports